<ng-container *ngIf="billingStatus.failed == false && !isSummaryLoading && !isLoading">
    <div class="container-fluid">
        <div *ngIf="this.billingStatus.isCAOnboard && this.billingStatus.setSellingPrice">
            <p-messages severity="warn" *ngIf="billingSummary?.pendingMerchants">
                <ng-template pTemplate>
                    <a (click)="navigateFn('m-b-s',{ to: 's-s-p', from:'bulk_enable' })" [ngClass]="{ 'isPointer': !editBilling, 'opacity': !editBilling}"
                        style="text-decoration: underline;text-decoration-color: black;color:black">
                        {{billingSummary?.pendingMerchants}} merchant{{billingSummary?.pendingMerchants > 1 ? 's are' : ' is'}} not enabled for Merchant Invoicing. Click here to enable {{billingSummary?.pendingMerchants > 1 ? 'them' : 'it'}}.
                    </a>
                </ng-template>
            </p-messages>
        </div>

        <!-- Top bar -->
        <div class="row shadow p-3 mb-4 bg-white rounded align-items-center" *ngIf="billingStatus?.isCAOnboard">

            <!-- Dropdown Actions -->
            <div class="col-12 col-md-1 mb-3 mb-md-0 d-flex justify-content-start justify-content-md-center">
                <div ngbDropdown class="d-inline-block">
                    <button class="btn btn-outline-primary btn-xs" ngbDropdownToggle>
                        <span class="feather icon-list"></span>
                    </button>
                    <div ngbDropdownMenu class="shadow p-3 bg-white rounded">
                        <a ngbDropdownItem (click)="download()" [disabled]="!invoiceRecords.length">
                            <span class="feather icon-download mr-1"></span> {{'htmlText.dwld' | translate}}
                        </a>
                        <a ngbDropdownItem (click)="navigateFn('m-b-s',{from:'pref_sell_price'})">
                            <span class="feather icon-globe mr-1"></span> {{'mb.settings' | translate}}
                        </a>
                        <a ngbDropdownItem [disabled]="isDisableProxyLogin" (click)="loginAs()">
                            <span class="feather icon-user mr-1"></span>{{'mb.loginToAccount' | translate}}
                        </a>
                        <a ngbDropdownItem (click)="navigateFn('m-b-s',{ to: 's-s-p', from:'bulk_update'})" 
                         [disabled]="!editBilling">
                            <span class="feather icon-layers mr-1"></span>
                            {{'mb.bulkUpdate' | translate}}
                        </a>
                    </div>
                </div>
            </div>

            <!-- Filter Form -->
            <div class="col-12 col-md-11">
                <form [formGroup]="filterForm" class="w-100">
                    <div class="row align-items-center justify-content-center">

                        <!-- Invoice Search -->
                        <div class="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
                            <ng-select [items]="invoiceIdsList" formControlName="invoiceId"
                                (search)="onSearchInvoiceId($event.term)" bindLabel="invoiceNumber"
                                bindValue="invoiceNumber" (change)="onSelectId($event)" placeholder="Search By Invoice"
                                [loading]="invoiceIdloading" [disabled]="!invoiceRecords.length" clearAllText="Clear"
                                [notFoundText]="notFoundText" [clearable]="true">
                            </ng-select>
                        </div>

                        <!-- Month Selector -->
                        <div class="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
                            <ng-select id="monthBox" formControlName="month" [disabled]="!invoiceRecords.length"
                                [items]="monthList" bindLabel="label" bindValue="value" placeholder="Month Selection"
                                [clearable]="true">
                            </ng-select>
                        </div>

                        <!-- Year Selector -->
                        <div class="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
                            <ng-select id="year" formControlName="year"
                                [items]="yearList" bindLabel="label" bindValue="value" placeholder="Year Selection"
                                [clearable]="true">
                            </ng-select>
                        </div>

                        <!-- Action Buttons -->
                        <div
                            class="col-12 col-sm-6 col-md-3 mb-3 mb-md-0 d-flex align-items-end justify-content-start justify-content-md-end">
                            <div class="d-flex flex-wrap gap-2 w-100 w-md-auto">
                                <button class="btn btn-outline-primary mr-2" [disabled]="!isFormValid || isLoading"
                                    (click)="searchFn()">
                                    <i class="feather icon-search mr-1"></i> Search
                                </button>
                                <button class="btn btn-outline-primary mr-2" [disabled]="!isFormValid || isLoading"
                                    type="button" (click)="clear();">
                                    Clear
                                </button>
                                <button class="btn btn-outline-primary" [disabled]="isLoading || disableFilter" (click)="searchFn()">
                                    <i class="feather icon-refresh-cw"></i>
                                </button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>


        <div>
            <!-- Empty state -->
            <div class="row justify-content-center text-center mt-5" *ngIf="!billingStatus?.isCAOnboard">
                <div class="col-12 col-sm-8 col-md-6">
                    <app-ilustration-with-message
                        text="You don't have a Collection Account yet. Please create one to start billing your merchants."
                        illustrationName="add.svg" severity="warn">
                    </app-ilustration-with-message>
                    <button type="button" class="btn btn-outline-primary btn-sm mt-3" style="min-width: 150px;"
                        (click)="addAccount()">
                        {{'mb.addAccount' | translate}}
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="!((billingSummary?.totalMerchants || 0) - (billingSummary?.pendingMerchants|| 0)) 
        && billingStatus.isCAOnboard == true && !isLoading 
        && !invoiceRecords.length" style="margin-top: 5%;text-align: center;">
            <h4>No invoice data available</h4>
        </div>
        <div *ngIf="((billingSummary?.totalMerchants || 0) - (billingSummary?.pendingMerchants|| 0)) && !invoiceRecords.length && !isFilter && !isLoading && errors.invoiceRecords != 500"
            style="margin-top: 5%;text-align: center;">
            <h4>Invoice generation will begin in the first week of the month.</h4>
        </div>
        <div *ngIf="errors.invoiceRecords == 500"
            style="margin-top: 5%;text-align: center;">
            <h4>Internal Server Error!!</h4>
        </div>
        <div *ngIf="isFilter && !invoiceRecords.length && !isLoading" style="margin-top: 5%;text-align: center;">
            <h4>No Invoices Found.</h4>
        </div>

    </div>
</ng-container>


<ng-container *ngIf="billingStatus?.isCAOnboard && invoiceRecords.length && !isLoading && !isSummaryLoading">

    <ng-container *ngFor="let invoice of invoiceRecords">

        <div class="card list-view card-list-bg mb-3">
            <div class="card-header list-header px-0 py-2 list">
                <div class="col-md-12 d-flex justify-content-between align-items-center  row pr-0 m-0">
                    <p class="card-text mt-1 text-left">
                        <span class="font-weight-bold">
                            <h5> {{(invoice.month +'-'+ 01 +'-'+invoice.year) |date:' MMM y' }}</h5>
                        </span>
                    </p>
                    <button class="btn btn-more pb-2 mr-1 align-center" id="dropdownManual"
                        (click)="navigateToInvoice(invoice)">
                        <span>
                            {{'htmlText.more' | translate}}
                        </span>
                        <span class="feather icon-chevrons-right"></span></button>
                </div>
            </div>
            <div class="card-body carding p-3">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex flex-column text-center">
                        <div class="mb-1">
                            <span>{{'mb.totalMerchants' | translate}}</span>
                        </div>
                        <div class="font-weight-bold mb-1">
                            <h5>{{invoice.totalMerchants}}</h5>
                        </div>

                    </div>
                    <div class="d-flex flex-column text-center">
                        <div class="mb-1">
                            <span>{{'mb.totalAmount' | translate}}</span>
                        </div>
                        <div class="font-weight-bold mb-1">
                            <h5>{{invoice.collectedAmount |currency }}</h5>
                        </div>

                    </div>
                    <div class="d-flex flex-column text-center">
                        <div class="mb-1">
                            <span>{{'mb.totalAmountPending' | translate}}</span>
                        </div>
                        <div class="font-weight-bold mb-1">
                            <h5>{{invoice.pendingAmount |currency}}</h5>
                        </div>

                    </div>
                    <div class="d-flex flex-column text-center">
                        <div class="mb-1">
                            <span>{{'mb.billedDate' | translate}}</span>
                        </div>
                        <div class="font-weight-bold mb-1">
                            <h5>{{invoice.lastBillingDate ? (invoice.lastBillingDate |date :'d MMM y') :'--'}}</h5>
                        </div>

                    </div>




                </div>
            </div>
        </div>

    </ng-container>


</ng-container>


<ng-container *ngIf="billingStatus.failed == true">
    <p-messages severity="error" id="p-message-css">
        <ng-template style="display: block;" pTemplate>
            Gateway Error
        </ng-template>
    </p-messages>
</ng-container>


<app-loading *ngIf="isLoading || isSummaryLoading"> </app-loading>